export default "__VITE_ASSET__CB1ufPa0__"